import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImportCsvComponent } from '@/common/import-csv/import-csv.component';
import { MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
	selector: 'app-transport-plane-import-dialog',
	standalone: true,
	imports: [ImportCsvComponent, MatDialogContent, MatDialogTitle],
	template: `<h1 mat-dialog-title>Importuj terminy samolotowe</h1>
		<mat-dialog-content>
			<app-import-csv
				requestUrl="/transport/import_flights/"
				method="post"
				(successUpload)="closeDialogWithSuccess()"
			></app-import-csv>
		</mat-dialog-content> `,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportPlaneImportDialogComponent {
	private readonly dialog = inject(MatDialogRef);

	closeDialogWithSuccess(): void {
		this.dialog.close(true);
	}
}
